import { APIData, appFetch } from ".";

export const newsAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<NewsItem[]>>("/news?page=" + page);
  },
  fetchItem(id: number) {
    return appFetch<APIData<NewsItem>>("/news/" + id);
  },
};
